import React from "react";

export const CosmicShell = ({ children }) => {
  return (
    <div className="relative min-h-screen">
      <div className="starfield" aria-hidden="true" />
      <div className="relative z-10">{children}</div>
    </div>
  );
};
